var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgShareSpecific = function SvgShareSpecific(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.38 13.42c.39.598.62 1.287.62 2.078v1.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.5c0-2.332-4.96-2.602-4.62-2.079zM9 11.997c-2.335 0-7 1.168-7 3.5v1.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.5c0-2.332-4.668-3.5-7-3.5zm0-2a2.992 2.992 0 0 0 2.99-3c0-1.656-1.334-3-2.99-3a3 3 0 0 0 0 6zM17.002 12A1.996 1.996 0 0 0 19 10c0-1.104-.89-2-1.997-2A2.002 2.002 0 0 0 15 10c0 1.104.897 2 2.003 2z"
  })));
};

export default SvgShareSpecific;